<template>
	
		<mapbase 
		:mapColor="mapColor" 
		:mapTitle="mapTitle" 
		:mapName="mapName" 
		:unit="unit" 
		:pieces="pieces"
		:cityD="cityD"
		:provicesD="provicesD"
		/>
		<!-- <mapbase /> -->
	
</template>

<script>
	import mapbase from './mapbase.vue'
	import '../../static/js/provinceWaterRate.js'
	import '../../static/js/cityWaterRate.js'
	export default {
		name: 'mapuse',
		components: {
			mapbase,
		},
		data(){
			return {
				cityD:cityWaterRate,
				provicesD:provinceWaterRate,
				unit:'%',
				mapName:'城市公共供水普及率',
				mapTitle:'2018年城市公共供水普及率地图(%)',
				mapColor:['#fff', '#D3E5E8', '#AEC6D4', '#8DADC2', '#6D93B0', '#4D7A9E','#2E648C'],
				pieces:[
							{
								min: 99.476441
							}, 
							{
								min: 97.010402,
								max: 99.476440
							},
							{
								min: 93.080846,
								max: 97.010401
							},
							{
								min: 86.363637,
								max: 93.080845
							},
							{
								min: 75.428572 ,
								max: 86.363636
							},
							{
								min: 53.475936,
								max: 75.428571
							},
							{
								min: 0,
								max: 53.475936
							}
							
						]
			}
		}
	}
</script>

<style scoped>
	.box{
		width: 100%;
		height: calc(100vh - 200px);
		margin: auto;
		/* border: 2px solid aquamarine; */
	}
	
	.search{
		margin-right: 30px;
		text-align: right;
		margin-bottom: 20px;
	}
	.search .el-input{
		width:30%
	}
	@media screen and (max-width:600px) {
		.search .el-input{
			width:50%
		}
	}
</style>
